import { Unstable_Grid2 as Grid } from '@mui/material';

import {
  presentationPriorityOptions,
  presentationTypeOptions as defaultPresentationPriorityOptions,
} from '@occc-app/routes/CampaignComponents/components/MarketingContent/consts';
import { Select, SelectData, TextField } from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';
import { DisplayCategorySelectField } from '@occc-app/routes/CampaignComponents/components/DisplayCategorySelect';

import { MarketingContentFormValuesPaths } from './types';

type PresentationDesignSectionProps = {
  presentationTypeEnabled?: boolean;
  presentationTypeOptions?: SelectData[];
  displayCategoriesEnabled?: boolean;
  presentationPriorityEnabled?: boolean;
  orderAheadEnabled?: boolean;
  isCategoryFieldVisible?: boolean;
};

const displayForOrderAheadOptions: SelectData[] = [
  { label: 'Display', value: 'true' },
  { label: 'Not Display', value: 'false' },
];

export const PresentationDesignSection = (props: PresentationDesignSectionProps) => {
  const {
    presentationTypeEnabled = false,
    presentationTypeOptions = defaultPresentationPriorityOptions,
    displayCategoriesEnabled = false,
    presentationPriorityEnabled = false,
    orderAheadEnabled = false,
    isCategoryFieldVisible = false,
  } = props;

  return (
    <Grid container spacing={3}>
      <Grid xs={12}>
        <Typography variant='subtitle1'>Presentation</Typography>
      </Grid>

      {presentationTypeEnabled && (
        <Grid xs={12} sm={3}>
          <Select
            name={'offer.presentationType' satisfies MarketingContentFormValuesPaths}
            label='Display Options'
            data={presentationTypeOptions}
            formControlProps={{ size: 'medium' }}
          />
        </Grid>
      )}

      {presentationPriorityEnabled && (
        <Grid xs={12} sm={3}>
          <Select
            name={'offer.presentationPriority' satisfies MarketingContentFormValuesPaths}
            label='Presentation Priority'
            data={presentationPriorityOptions}
            formControlProps={{ size: 'medium' }}
          />
        </Grid>
      )}

      {displayCategoriesEnabled && (
        <Grid xs={12} sm={3}>
          <DisplayCategorySelectField
            name={'displayCategories' satisfies MarketingContentFormValuesPaths}
            label='Display Categories'
          />
        </Grid>
      )}

      {displayCategoriesEnabled && isCategoryFieldVisible && (
        <Grid xs={12} sm={3}>
          <TextField
            name={'offer.category' satisfies MarketingContentFormValuesPaths}
            label='Category'
          />
        </Grid>
      )}

      {orderAheadEnabled && (
        <Grid xs={12} sm={3}>
          <Select
            name={'offer.displayForOrderAhead' satisfies MarketingContentFormValuesPaths}
            label='Display for Order Ahead'
            data={displayForOrderAheadOptions}
            formControlProps={{ size: 'medium' }}
            fieldProps={{
              parse: (value: string) => value === 'true',
              format: (value: boolean | undefined) => String(value ?? false),
            }}
          />
        </Grid>
      )}
    </Grid>
  );
};
